import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SavedFilterApi } from '../../Common/Filter/models/saved-filter-api.model';
import { MultiBaseAbstractApi } from '../genericApi/multi-base-abstract.api';
import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';


@Injectable()
export class SavedFilterApiService extends MultiBaseAbstractApi<SavedFilterApi, SavedFilterApi> {
    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }

    getList(): Observable<SavedFilterApi[]> {
        const slug: string = '/monitoring-filters';

        return this.neptuneApi.api<SavedFilterApi[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    getById(id: number): Observable<SavedFilterApi> {
        const slug: string = `/monitoring-filters/${id}`;

        return this.neptuneApi.api<SavedFilterApi>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    };

    create(resource: SavedFilterApi): Observable<number> {
        const slug: string = '/monitoring-filters';

        return this.neptuneApi.api<number>(
            slug,
            resource,
            HttpVerbsEnum.POST
        );

    };

    update(resource: SavedFilterApi): Observable<number> {
        const slug: string = `/monitoring-filters/${resource.id}`;

        return this.neptuneApi.api<number>(
            slug,
            resource,
            HttpVerbsEnum.PUT
        );
    };

    deleteById(id: number): Observable<number> {
        const slug: string = `/monitoring-filters/${id}`;

        return this.neptuneApi.api<number>(
            slug,
            null,
            HttpVerbsEnum.DELETE
        );
    };

    addFavorite(id: number): Observable<number> {
        const slug: string = '/monitoring-filters/favourite';

        return this.neptuneApi.api<number>(
            slug,
            id,
            HttpVerbsEnum.POST
        );

    };

    removeFavorite(id: number): Observable<number> {
        const slug: string = '/monitoring-filters/favourite';

        return this.neptuneApi.api<number>(
            slug,
            id,
            HttpVerbsEnum.DELETE
        );

    };

}
